import { render } from "./EconomicInformation.vue?vue&type=template&id=2f5fd8c3"
import script from "./EconomicInformation.vue?vue&type=script&lang=js"
export * from "./EconomicInformation.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__